module.exports = __webpack_public_path__ + "static/media/6.question.d2fa7928.mp4";